import { useImage } from "@hooks/useImage"
import { useRoutes } from "@hooks/useRoutes"

const useCollectionImages = (collections: GatsbyTypes.SanityCollection[]) => {
  const { getGatsbyImage } = useImage()
  const { urlResolver } = useRoutes()

  const items = collections?.map(item => ({
    ...item,
    key: item?._key,
    image: getGatsbyImage(item?.image),
    link: urlResolver(item),
  }))

  return items
}

export default useCollectionImages
